export default __webpack_public_path__ + "static/media/HPSimplified_W_Bd.c4c9a85e.woff2";